import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const BulkDocsPage = lazy(() => import("@/features/dashboard/pages/bulk-docs"));

export const Route = createFileRoute("/(app)/dashboard/bulk-docs")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading Bulk Docs...</div>}>
      <BulkDocsPage />
    </Suspense>
  ),
});
